// @flow
import React from 'react';

export const ArrayField = ({ userValue, definition }: { userValue: Object, definition: Object }) => {
  const arrayValue = JSON.parse(userValue.value);

  return (
    <div>
      {arrayValue.map((item, index) => (
        <p key={index}>{`${definition.values[item] ? definition.values[item] : item}`}</p>
      ))}
    </div>
  );
};
